module.exports = __webpack_public_path__ + "static/malar-symbol-DND3_FnP-eda68e2e0236f16ba9a75020bf335de5.webp";